const trackGoogleAnalytics = (event_name, event_params = {}) => {
  if (!window.dataLayer) return;

  window.dataLayer.push({ event: event_name, ...event_params });
};

export { trackGoogleAnalytics };
